export const FullPageLoading = () => {
  return (
    <p className="grid h-screen animate-pulse place-content-center text-lg">
      Loading Supply25...
    </p>
  );
};
